import * as React from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { isAuthenticated } from '../../data/providers/userProvider';
import PageHeader from '../pageHeader/PageHeader';
import { ErrorBoundary } from '../shared/ErrorBoundary';

interface IProps {
  // tslint:disable-next-line:no-any
  component: any;
  path?: string;
  exact?: boolean;
}

const Layout = ({
  component: Component,
  path,
  exact,
}: IProps): React.ReactElement => {
  const renderFn = (props: RouteComponentProps): React.ReactElement => {
    return isAuthenticated() ? (
      <React.Fragment>
        <PageHeader />
        <ErrorBoundary>
          <Component {...props} />
        </ErrorBoundary>
      </React.Fragment>
    ) : (
      <Redirect
        to={{
          pathname: '/',
          state: { from: props.location },
        }}
      />
    );
  };
  return <Route path={path ? path : null} exact={exact} render={renderFn} />;
};

export { Layout };
